import { boldFont, whiteColor } from '@app/styles';
import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  top: 60px;
  width: 280px;
  box-shadow: 0 11px 20px 0 rgba(47, 54, 65, 0.5);
  background: ${whiteColor};
  padding: 16px;
  border-radius: 8px;
  height: calc(100vh - 240px);
  overflow-x: hidden;
  overflow-y: auto;
`;
export const Seperator = styled.div`
  opacity: 0.2;
  border-bottom: 1px dashed #202731;
  margin: 16px 0px;
`;
export const CompletedContainer = styled.div``;
export const ApprovedContainer = styled.div``;
export const DocumentContainer = styled.div``;
export const Heading = styled.div`
  ${boldFont}
  font-size: 14px;
  line-height: 18px;
  color: #202731;
  opacity: 0.5;
  margin-bottom: 16px;
`;

export const NoResults = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: #202731;
  margin-top: 16px;
`;

export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  //   width: 100%;
  //   height: 100%;
`;

export const ResultValue = styled.div`
  ${boldFont}
  font-size: 14px;
  line-height: 18px;
  color: #202731;
  margin-bottom: 8px;
`;

export const SeeMore = styled.div`
  text-align: center;
  margin-top: 32px;
  color: #202731;
  background: #ccc;
  padding: 8px;
  border-radius: 8px;
`;
